import * as _ from 'lodash-es';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const POST_FIELDS_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment populatePostsWithFullTopics_posts on SlimPostFields {
    topics {
      id
    }
  }
`);

const populatePostsWithFullTopics = <
  Post extends Omit<DocumentType<typeof POST_FIELDS_FRAGMENT>, '__typename'>,
  Topic,
>(
  posts: Post[],
  topicMap: { [id: string]: Topic },
): (Post & { topics: Topic[] })[] =>
  posts.map((post) => ({
    ...post,
    topics: _.compact(post.topics?.map((topic) => topicMap[topic.id])),
  }));

export default populatePostsWithFullTopics;
